import React from 'react';
import { useTranslation } from 'react-i18next';

export const ApproachPage: React.FC = () => {
  const { t } = useTranslation('pages');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-[#0B1F3A]">{t('approach.title')}</h1>
        <p className="mt-2 text-gray-600">
          {t('approach.subtitle')}
        </p>
      </div>

      <div className="space-y-8 text-gray-700">
        <section>
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('approach.step1Title')}</h2>
          <p>{t('approach.step1Text')}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('approach.step2Title')}</h2>
          <p>{t('approach.step2Text')}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('approach.step3Title')}</h2>
          <p>{t('approach.step3Text')}</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('approach.step4Title')}</h2>
          <p>{t('approach.step4Text')}</p>
        </section>
      </div>
    </div>
  );
};
